import React from "react";
import ResourcesList from "../../components/Resources/ResourcesList";

const Resources = () => {
  return <ResourcesList />;
};

export default Resources;
